import AttachmentList, { AttachmentListProps } from "./AttachmentList";

export const FeatureAttachmentList: React.FC<AttachmentListProps> = (props) => <AttachmentList {...props} type="layer_feature" />;
